import { render, staticRenderFns } from "./bindFailed.vue?vue&type=template&id=bb935f64&scoped=true&"
import script from "./bindFailed.vue?vue&type=script&lang=js&"
export * from "./bindFailed.vue?vue&type=script&lang=js&"
import style0 from "./bindFailed.vue?vue&type=style&index=0&id=bb935f64&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb935f64",
  null
  
)

export default component.exports